import moviesandcocktails from "./assets/moviesandcocktails.PNG";
import pieceofcake from "./assets/pieceofcake.PNG";
import codequizgame from "./assets/codequizgame.PNG";
import weatherdashboard from "./assets/weatherdashboard.PNG";
import mvctechblog from "./assets/MVCTechBlog.PNG";
import tailorthrift from "./assets/tailorthrift.PNG";

const Project = () => {
  return (
    <div className="container work">
      <a id="work"></a>
      <div className="row">
        <div className="col-sm-2 workTitle">
          <h4>Work</h4>
        </div>
        {/* <!-- Project1 container with button links to live page and GitHub Repo --> */}
        <section className="col-sm-5 s5 workProject3">
          <img
            src={tailorthrift}
            className="img-fluid"
            alt="Responsive image"
          />
          <div className="work-container-title">
            <h5>Tailor Thrift</h5>
            <p>
              Bring confidence to what you wear. We aim to help our customers
              find purpose in the repurposed. We do this by providing selections
              of quality inspected previously-owned clothing combined with our
              alteration services to get the right fit. E-commerce site with
              React.js front end, MongoDB/GraphQL/Apollo back end, and JWT
              Session Authentication.
            </p>
            <a
              href="https://tailorthrift-wymore.herokuapp.com/"
              className="waves-effect waves-light btn-small"
              target="_blank"
              rel="noreferrer"
            >
              Live Page
            </a>
            <a
              className="waves-effect waves-light btn-small"
              href="https://github.com/yardboy2401/tailorthrift-wymore"
              target="_blank"
              rel="noreferrer"
            >
              GH Repo
            </a>
          </div>
        </section>
        <section className="col-sm-5 s5 workProject2">
          <img src={pieceofcake} className="img-fluid" alt="Responsive image" />
          <div className="work-container-title">
            <h5>Piece of Cake</h5>
            <p>
              Online ordering for quick pickup of your favorite bakery items.
              Pay using Stripe payment processing. This app uses handlebars.js
              for rendering front end pages, a MySQL/Sequelize back end, and
              Express-Session Authentication.
            </p>
            <a
              className="waves-effect waves-light btn-small"
              href="https://project2-pieceofcake.herokuapp.com/"
              target="_blank"
              rel="noreferrer"
            >
              Live Page
            </a>
            <a
              className="waves-effect waves-light btn-small"
              href="https://github.com/yardboy2401/project2-pieceofcake"
              target="_blank"
              rel="noreferrer"
            >
              GH Repo
            </a>
          </div>
        </section>
      </div>
      <div className="row">
        <div className="col-sm-2 s2"></div>
        {/* <!-- code quiz homework container with button links to live page and GitHub Repo --> */}
        <div className="col-sm-5 s5 mvcTechBlog">
          <div className="card-image">
            <img
              src={mvctechblog}
              className="img-fluid"
              alt="Responsive image"
            />
            <h5>MVC Tech Blog</h5>
            <p>
              Tech Blog with Session Authentication for Blogs/Comments by User.
              Developers can publish their blog posts and comment on other
              developers' posts as well.
            </p>
            <a
              className="waves-effect waves-light btn-small"
              href="https://week14-mvctechblog-wymore.herokuapp.com/"
              target="_blank"
              rel="noreferrer"
            >
              Live Page
            </a>
            <a
              className="waves-effect waves-light btn-small"
              href="https://github.com/yardboy2401/MVC-TechBlog-Wymore"
              target="_blank"
              rel="noreferrer"
            >
              GH Repo
            </a>
          </div>
        </div>
        {/* <!-- weather dashboard homework with button links to live page and GitHub Repo --> */}
        <section className="col-sm-5 s5 workProject1">
          <img
            src={moviesandcocktails}
            className="img-fluid"
            alt="Responsive image"
          />
          <div className="work-container-title">
            <h5>Movies and Cocktails</h5>
            <p>
              Search for movie poster/synopsis and obtain drink recommendations.
              Uses 2 different 3rd party API calls to OMDb Movies and CocktailDB
              for drink suggestions.
            </p>
            <a
              href="https://jonkhunkle.github.io/Movies-and-Cocktails/"
              className="waves-effect waves-light btn-small"
              target="_blank"
              rel="noreferrer"
            >
              Live Page
            </a>
            <a
              className="waves-effect waves-light btn-small"
              href="https://github.com/JonkHunkle/Movies-and-Cocktails/"
              target="_blank"
              rel="noreferrer"
            >
              GH Repo
            </a>
          </div>
        </section>
      </div>
      <div className="row">
        <div className="col-sm-2 s2"></div>
        {/* <!-- code quiz homework container with button links to live page and GitHub Repo --> */}
        <div className="col-sm-5 s5 codeQuizGame">
          <div className="card-image">
            <img
              src={codequizgame}
              className="img-fluid"
              alt="Responsive image"
            />
            <h5>Code Quiz Game</h5>
            <p>
              Play a fun JavaScript timed quiz and try for high score. High
              score(s) saved to local storage.
            </p>
            <a
              className="waves-effect waves-light btn-small"
              href="https://yardboy2401.github.io/CodeQuizGame-Wymore/"
              target="_blank"
              rel="noreferrer"
            >
              Live Page
            </a>
            <a
              className="waves-effect waves-light btn-small"
              href="https://github.com/yardboy2401/CodeQuizGame-Wymore"
              target="_blank"
              rel="noreferrer"
            >
              GH Repo
            </a>
          </div>
        </div>
        {/* <!-- weather dashboard homework with button links to live page and GitHub Repo --> */}
        <div class="col-sm-5 s5 weatherDashboard">
          <div class="card-image">
            <img
              src={weatherdashboard}
              class="img-fluid"
              alt="Responsive image"
            />
            <h5>Weather Dashboard</h5>
            <p>
              Search for Daily/Extended Forecast by City (Recent search history
              saved to local storage). This app uses a 3rd party OpenWeather API
              (2 different calls) for weather data.
            </p>
            <a
              class="waves-effect waves-light btn-small"
              href="https://yardboy2401.github.io/WeatherDashboard-Wymore/"
              target="_blank"
              rel="noreferrer"
            >
              Live Page
            </a>
            <a
              class="waves-effect waves-light btn-small"
              href="https://github.com/yardboy2401/WeatherDashboard-Wymore"
              target="_blank"
              rel="noreferrer"
            >
              GH Repo
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project;
